<!--
  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
  ~ No part of this publication may be reproduced, distributed,
  ~ or transmitted in any form or by any means, including photocopying, recording,
  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
  ~ except in the case of brief quotations embodied in critical
  ~ reviews and certain other noncommercial uses permitted by copyright law.
  ~  author : vhe
  ~  date : 02/03/2021 07:39
  -->

@if (resources()) {
  <div #container class="planning">
    <infl-calendar-horizontal-resources
      [resources]="resources()"
      [resourceTitle]="resourceTitle()"
      [heightTitle]="70"
      (changeDisplay)="generateTasks()"
    ></infl-calendar-horizontal-resources>
    <div class="calendar" [ngClass]="{ safari: isSafari }">
      <div class="header">
        <div class="header-content">
          {{ date() | date: 'MMMM yyyy' : '' : 'fr' | uppercase }}
        </div>
      </div>
      <table class="body">
        <thead>
          <tr #header>
            @for (day of days; track day.day) {
              <th
                class="day"
                [ngClass]="{ 'current-day': isCurrentDay(day.day) }"
              >
                <div class="cell-header">
                  <span
                    class="day"
                    [innerHTML]="
                      day.day.toDate()
                        | customDate: 'DD' : translate.currentLang : true
                        | uppercase
                    "
                    >{{ day.label }}</span
                  >
                </div>
              </th>
            }
          </tr>
        </thead>
        <tbody
          (mousemove)="onMouseMove($event)"
          (dragleave)="onDragLeaveTbody()"
        >
          @for (group of resources(); track group.id; let j = $index) {
            <tr class="group-header-row">
              @for (day of days; track day.day) {
                <td
                  [ngClass]="{
                    'current-day': isCurrentDay(day.day),
                    'last-day':
                      !group.isOpened &&
                      isCurrentDay(day.day) &&
                      j + 1 === resources().length,
                  }"
                ></td>
              }
            </tr>
            @if (group.isOpened) {
              @for (
                resource of group.tasksGroups;
                track resource.id;
                let i = $index
              ) {
                <tr
                  class="resource-row"
                  [ngClass]="{ 'last-row': i + 1 === group.tasksGroups.length }"
                  [ngStyle]="{ height: resource.height + 'px' }"
                >
                  @for (day of days; track day.day) {
                    <td
                      #dayRow
                      inflDayRow
                      class="day"
                      [date]="day.day"
                      [resource]="resource.id"
                      [teleworks]="teleworks()"
                      [ngClass]="{
                        selected: day.selected && selectedGroup === resource,
                        'current-day': isCurrentDay(day.day),
                        'last-day':
                          i + 1 === group.tasksGroups.length &&
                          j + 1 === resources().length &&
                          isCurrentDay(day.day),
                      }"
                      [ngStyle]="{ 'background-color': day.backgroundColor }"
                      (mousedown)="startSelection($event, day, resource)"
                      (dragenter)="$event.preventDefault()"
                      (dragleave)="$event.preventDefault()"
                      (dragover)="onDragOver($event, dayRow)"
                      (drop)="
                        onDrop($event, day.day.date(), group.id, resource.id)
                      "
                      (dblclick)="
                        onClickOnSelection(selection, $event, resource, true)
                      "
                      (mouseover)="overZone($event, day, resource)"
                      (hasTelework)="setTelework(dayRow)"
                    ></td>
                  }
                </tr>
              }
            }
          }
        </tbody>
      </table>
      <div class="tasks">
        @for (task of viewTasks(); track task.task.id) {
          <div
            class="task"
            [ngClass]="{ enable: enable() }"
            [ngStyle]="task.style"
            [draggable]="canDrag() && task.task.enable"
            (click)="onTaskClick($event, task.task)"
            (mouseenter)="taskHover.emit(task.task)"
            (mouseleave)="taskHover.emit(null)"
            (dblclick)="onTaskClick($event, task.task, true)"
            (mousemove)="onMouseMove($event)"
            (dragstart)="onDragStart(task, $event)"
            (dragover)="allowDrop($event)"
          >
            @if (enable() && canResize() && task.task.enable) {
              <div
                class="resize"
                (mousedown)="startResize($event, task.task, 'left')"
              >
                <span class="fal fa-ellipsis-v"></span>
              </div>
            }
            <div
              class="background"
              [ngStyle]="{
                'background-color':
                  task.task.backgroundColor.length === 9
                    ? task.task.backgroundColor
                    : task.task.backgroundColor + 'BF',
              }"
            >
              <div class="text">
                @if (task.task.icon) {
                  <span class="icon fal fa-{{ task.task.icon }}"></span>
                }
                {{ task.task.label }}
              </div>
            </div>
            @if (enable()) {
              <div class="remove">
                <span class="fal fa-times"></span>
              </div>
            }
            @if (enable() && canResize() && task.task.enable) {
              <div
                class="resize right"
                (mousedown)="startResize($event, task.task, 'right')"
              >
                <span class="fal fa-ellipsis-v"></span>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
}
